import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, FieldArray } from 'formik';
import { Box, Stack, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutline';

import IconButton from '@ui-lib/components/IconButton';
import { createSx } from '@ui-lib/utils';

import { CreateBolFormValues } from '../../const';

const sx = createSx({
  container: {
    overflowX: 'auto',
    width: '100%',
    scrollSnapType: 'x mandatory',
  },
  spacer: {
    flexBasis: 'calc(10% - 64px)',
  },
  photoItem: {
    flex: '0 0 90%',
    position: 'relative',
    aspectRatio: {
      xs: '9/12',
      sm: '4/3',
    },
    background: 'black',
    scrollSnapAlign: 'center',
    borderRadius: 2,
  },
  img: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  deleteButton: {
    position: 'absolute',
    top: '24px',
    right: '24px',
  }
});

export const PhotosContainer = connect<Record<string, never>, CreateBolFormValues>(({
  formik: { values }
}) => {
  const { t } = useTranslation();
  const { photos } = values;
  return (
    <Stack>
      <Typography variant='body2' mb={2} >
        {t('bolPhotos')}: <strong>{photos.length}</strong>
      </Typography>
      <Stack direction='row' spacing={2} sx={sx.container}>
        <Box sx={sx.spacer} />
        <FieldArray name='photos'>
          {arrayHelpers => (
            <>
              {photos.map((photo, index) => (
                <Box key={photo} sx={sx.photoItem}>
                  <Box component='img' src={photo} sx={sx.img} />
                  <IconButton
                    variant='tonal'
                    title={t('delete')}
                    onClick={() => arrayHelpers.remove(index)}
                    sx={sx.deleteButton}
                    color='error'
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}
            </>
          )}
        </FieldArray>
      </Stack>
    </Stack>
  );
});
